import {h, render, Component} from 'preact';

import authContainer from '../tags/auth-container';

export class PasswordExpired extends Component {
    constructor() {
        super();
    }

    goToChangePassword = () => {
        this.props.history.push({
            pathname: '/change-password',
            search: location.search
        })
    };

    render({}, {}) {
        return (
            <section className='auth-modal-container password-expired'>
                <div className='form d-flex flex-column justify-content-between'>
                    <div>
                        <h3>Your password has expired.</h3>
                        <p>You are now required to change your password to continue working.</p>
                    </div>
                    <div className='change-password-btn d-flex justify-content-end'>
                        <a className='button button-prime' onClick={this.goToChangePassword}>
                            Change password
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

export default authContainer(PasswordExpired);



// WEBPACK FOOTER //
// ./src/scripts/views/change-password/password-expired.js